import React from 'react';
//import BusinessCard from './BusinessCard';
import { useNavigate } from "react-router-dom";
//import { BusinessCardData } from '../../data/CardData';

const BusinessCardListProWifi = () => {
    const role = sessionStorage.getItem('RoleProFi')
    // console.log("abc",Role);

   

    const navigate = useNavigate()
    const redirectDashboardPage = () => {
        // navigate('/dashboard')
         navigate('/cardListProfi')
    }
    

    const redirectProwifiBusinessShowAllMeetings = () => {
        navigate("/businessShowAllMeetOffice")
    }
    const redirectProWifiBusinessContact = () => {
        navigate("/businessContactProWifi")
    }
    const redirectProWifiBusinessLead = () => {
        navigate("/businessLeadProWifi")
    }
    const redirectProWifiBusinessOpportunity = () => {
        navigate("/businessOpportunityProWifi")
    }
    const redirectProWifiBusinessCaf = () => {
        navigate("/businessCaf")
    }



    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span className='' style={{ cursor: 'pointer' }} onClick={redirectDashboardPage}>
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className='p-1 m-3'>Office Menu</span>
                </div>
            </div>
            
            <div className="container-fluid Business-main">
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">


                {/* {console.log("role",role)} */}
                
                    {role === "BDR Team" ? (

                        <>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectProWifiBusinessContact}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Contact Management</p>
                                    </div>
                                </div>
                            </div>
                        </>

                    ) : (
                        <>

                            

                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectProwifiBusinessShowAllMeetings}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">All Business Meetings</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectProWifiBusinessContact}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Contact Management</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectProWifiBusinessLead}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Lead</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectProWifiBusinessOpportunity}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Opportunity</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectProWifiBusinessCaf}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">CAF</p>
                                    </div>
                                </div>
                            </div>


                        </>)}
                </div>
            </div>
        </>
    );
}

export default BusinessCardListProWifi;
